import { Component, Input, OnInit } from '@angular/core';
import { VerifyAndEarnPromotion } from 'src/app/models/promotions';

@Component({
  selector: 'app-register-with-referralid',
  templateUrl: './register-with-referralid.component.html',
  styleUrls: ['./register-with-referralid.component.scss']
})
export class RegisterWithReferralidComponent implements OnInit {

  @Input() referralId: string;
  @Input() referrerName: string;
  @Input() promotion: VerifyAndEarnPromotion;
  @Input() isExperimentReferral: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
